// 不在顶层 import SlsTracker，先声明一个空变量
let SlsTracker = null
import { v4 as uuidv4 } from "uuid"

const opts = {
  host: "us-west-1.log.aliyuncs.com",
  project: "pai-us",
  logstore: "web-remaker",
  time: 0.05,
  count: 1,
}

// 获取浏览器类型时，也必须先判断 process.client
function getBrowserType() {
  if (!process.client) return "unknown_browser"
  const userAgent = navigator.userAgent
  if (userAgent.indexOf("Chrome") !== -1) {
    return "chrome"
  } else if (userAgent.indexOf("Safari") !== -1) {
    return "safari"
  } else if (userAgent.indexOf("Firefox") !== -1) {
    return "firefox"
  } else if (userAgent.indexOf("Edge") !== -1 || userAgent.indexOf("Edg") !== -1) {
    return "edge"
  } else if (userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident") !== -1) {
    return "internet_explorer"
  } else {
    return "unknown_browser"
  }
}

// 让这段只在浏览器端运行
if (process.client) {
  // 动态加载浏览器专用的 SlsTracker
  SlsTracker = require("@aliyun-sls/web-track-browser").default

  try {
    if (!localStorage.getItem("web-model-uuid")) {
      localStorage.setItem(
          "web-model-install-time",
          Math.round(Date.now() / 1000).toString()
      )
      localStorage.setItem("web-model-uuid", uuidv4())
      // 第一次访问，触发一次上报
      sendAli("web-face-vary", "user_install")
    }
  } catch (error) {
    // localStorage 访问失败或私密模式下可能出错，可忽略
  }
}

// 对外暴露的上报方法
export function sendAli(event_category, event_operate, event_tag) {
  // 如果在服务端、或 SlsTracker 还没加载，就直接 return
  if (!process.client || !SlsTracker) return

  // 构造要发送的日志数据
  const sendData = {
    extension_name: opts.logstore,
    uuid: localStorage.getItem("web-model-uuid"),
    install_time: localStorage.getItem("web-model-install-time"),
    event_time: Math.round(Date.now() / 1000).toString(),
    event_category: event_category || "",
    event_operate: event_operate || "",
    event_tag: event_tag || "",
    type: getBrowserType(),
    language: navigator.language,
    url: location.href,
    user_id: localStorage.getItem("web-model-user") || "0",
    isMobile: navigator.userAgent.toLowerCase().includes("mobile") ? "1" : "0",
    isPay:
        localStorage.getItem("userInfo") &&
        JSON.parse(localStorage.getItem("userInfo")).payment
            ? JSON.parse(localStorage.getItem("userInfo")).payment
            : false,
  }

  // 实例化并发送日志
  const logger = new SlsTracker(opts)
  logger.send(sendData)
}
